<template>
  <v-container :fluid="true">
    <v-card>
      <v-toolbar>
        <v-toolbar-title>
          {{ $t('gui.landingpage') }}
        </v-toolbar-title>
      </v-toolbar>
      <v-card-title>
        {{ $t('gui.landingpageinfo') }}
      </v-card-title>
      <v-select
        v-model="siteLanguage"
        :label="$t('gui.prefferedLanguage')"
        style="width: 40vw; color: var(--color-white)"
        variant="solo-filled"
        :items="getSupportedLanguages()"
        item-value="code"
        item-title="langname"
        @update:modelValue="setThisSiteLanguage"
      />
      <v-card-actions>
        <v-spacer />
        <v-btn :text="$t('gui.next')" append-icon="mdi-page-next-outline" :to="{name: 'LandingPageLanguage'}" />
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import adminStore from '@/stores/adminstore.js'
import { mapActions, mapState, mapGetters ,setActivePinia} from 'pinia'
import { useToast } from 'vue-toastification'
const toast = useToast()

import DOMPurify from 'dompurify'

import nb from '@/assets/md/landingpage_nb.md'
import en from '@/assets/md/landingpage_en.md'

import { marked } from 'marked'
import { storeToRefs } from 'pinia'
  import { watch } from 'vue'

export default {
  name: 'LandingPage',
  components: {},
  props: {},
  setup() {
   setActivePinia(adminStore)
  },
  data() {
    return {
      siteLanguage: 'nb',
      gotTranslation: false,
      updateTranslate: 0,
      HTMLToView:'',
     // language: '',
      doc: {
        nb,
        en
      }
    }
  },
  computed: {
   //...mapGetters(adminStore, ["getLang"])
  },
  mounted() {
    this.language = this.$root.$i18n.locale
    localStorage.setItem('trlang', 'nb')
  },
  beforeMount() {
    
  },
  created() {},
  methods: {
  // ...mapActions(adminStore, ["setSiteLanguaage"]),
   setThisSiteLanguage() {
     console.log('setThisSiteLanguage (%s)',this.siteLanguage)
   let aStore = adminStore()
  aStore.sitelanguage = this.siteLanguage
     localStorage.setItem('trlang', this.siteLanguage)
      //this.setSiteLanguage(this.siteLanguage)
 //    console.log('sitelanguage is (%s)', aStore.sitelanguage)
     this.updateTranslate++
     this.$router.push({
       name: 'LandingPageLanguage'
     }).catch(()=>{})
   },
    doEdit() {
      this.$router.push({
        name: 'EditorTest'
      })
    },
    getSupportedLanguages() {
      let aStore = adminStore()
      return aStore.languagecodes
    }
  }
}
</script>

<style scoped>
.mdtext {
  padding: 1vh 2vw 1vh 2vw;
}

.medtext p a {
  color: red;
}
</style>
